module.exports = __webpack_public_path__ + "static/img/bg-jgpt-case-rail.bf477f2e.png";